import BathTowelsRobesSection from './BathTowelsRobesSection';

export default BathTowelsRobesSection;
